export function noop() {
  return void 0;
}
export function mapValues(value, iterator) {
  return Object.fromEntries(Object.entries(value).map(function (_ref) {
    var k = _ref[0],
        v = _ref[1];
    return [k, iterator(v)];
  }));
}